var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FBA919"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_592_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9473 9.067C17.891 9.10215 15.9258 11.0533 13.5844 13.3982C9.93164 17.0615 9.31289 17.6979 9.22148 17.8772C9.05273 18.2041 9 18.4291 9 18.8193C9 19.2236 9.09492 19.5647 9.30234 19.8916C9.45703 20.1377 15.8555 26.5256 16.1262 26.7049C16.6852 27.074 17.4973 27.1057 18.1195 26.7822C18.3059 26.6873 18.9281 26.0791 22.616 22.3982C24.9715 20.0463 26.9227 18.0811 26.9508 18.0283C27.0281 17.8807 27.0246 10.7264 26.9473 10.424C26.7785 9.78067 26.2195 9.22168 25.5762 9.05293C25.3969 9.00723 24.8801 9.0002 21.709 9.0002C18.1828 9.0002 18.0492 9.00372 17.9473 9.067ZM25.4496 10.1779C25.65 10.2904 25.7695 10.4205 25.8574 10.6279C25.9066 10.744 25.9102 11.1658 25.9102 14.1611V17.5607L21.8215 21.6494C18.6504 24.8205 17.6977 25.7557 17.5641 25.8225C17.3391 25.935 17.0332 25.942 16.8258 25.84C16.6219 25.7416 10.2199 19.3326 10.1426 19.1533C10.0652 18.96 10.0723 18.626 10.1637 18.4467C10.2129 18.3447 11.5348 17.0018 14.3543 14.1752L18.4746 10.0549L21.8672 10.0619L25.2598 10.0725L25.4496 10.1779Z",
    fill: "#FBA919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8141 12.0625C21.3852 12.2136 21.0407 12.516 20.8473 12.9168C20.2637 14.1156 21.2797 15.5007 22.5981 15.3004C23.4313 15.1703 24.0114 14.4988 24.0114 13.6621C24.0114 12.9765 23.6739 12.4316 23.0621 12.1363C22.8161 12.0203 22.7703 12.0097 22.4118 11.9992C22.0883 11.9886 21.9899 11.9992 21.8141 12.0625ZM22.6438 13.1593C23.0024 13.3984 23.02 13.8941 22.6789 14.1191C22.4961 14.2386 22.352 14.2597 22.1657 14.1894C21.786 14.0418 21.6524 13.5953 21.902 13.2824C22.0637 13.075 22.4293 13.0152 22.6438 13.1593Z",
    fill: "#FBA919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_592_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCancel);
export default __webpack_public_path__ + "static/media/no_cancel.ad28b34b63f1ea6c595fc15f5876d0a0.svg";
export { ForwardRef as ReactComponent };